import Vue from "vue";
import moment from "moment";


// filtro de fecha cuando la fecha en yy-mm-dd devuelve solo fecha dd/mm/aa
const fecha = function(date) {

    if(date){
    
        //let dateTime = new Date(date).toISOString().substr(0, 10)
        let dateTime = moment(date).format("YYYY-MM-DD")

        if (!dateTime) return null
        const [year, month, day] = dateTime.split('-')
        return `${day}/${month}/${year}`

    }else{
        return ""
    }
}

const dateformat=function (date) {
  if(date){
    return moment(date).format("YYYY-MM-DD");
  }
  return "";
}

// filtro de fecha cuando la fecha viene fecha y hora  devuelve solo fecha dd/mm/aa
const fechaHora = function(date) {
  //let dateTime = new Date(date).toISOString().substr(0, 10)
  if (!date) return null;
  let dateTime = moment(date).format("YYYY-MM-DD");
  const [year, month, day] = dateTime.split("-");
  return `${day}/${month}/${year} `;
};

// filtro de fecha cuando la fecha viene fecha y hora  devuelve solo fecha dd/mm/aa hora a 12hrs
const fullFechaHora = function(date) {
  //let dateTime = new Date(date).toISOString().substr(0, 10)
  if (!date) return null;
  return moment(date).format("YYYY-MM-DD h:mm a");
};

// cambiar formato de hora a 12hrs
const formatoHora = function(hora) {
  if (!hora) return null;
  var horaNew = parseInt(hora.substr(0, 2));
  var horaFormato = "";

  // si es pm
  if (horaNew >= 12) {
    if (horaNew == 12) {
      horaFormato = `${horaNew}:${hora.substr(3, 2)} PM`;
    } else if (horaNew > 12 && horaNew < 22) {
      horaFormato = `0${horaNew - 12}:${hora.substr(3, 2)} PM`;
    } else {
      horaFormato = `${horaNew - 12}:${hora.substr(3, 2)} PM`;
    }
  }

  // si es am
  else {
    if (horaNew == 0) {
      horaFormato = `12:${hora.substr(3, 2)} AM`;
    } else if (horaNew >= 1 && horaNew < 10) {
      horaFormato = `0${horaNew}:${hora.substr(3, 2)} AM`;
    } else {
      horaFormato = `${horaNew}:${hora.substr(3, 2)} AM`;
    }
  }

  if (!horaFormato) return null;
  //const [year, month, day] = date.split('-')
  return horaFormato;
};

/**
 * validar telefono
 */
const telefono = function(e) {
  let keyCode = e.keyCode;
  let digito = e.key;
  if (
    isNaN(digito) &&
    keyCode !== 187 &&
    keyCode !== 8 &&
    keyCode !== 37 &&
    keyCode !== 39
  ) {
    return e.preventDefault();
  }
  return true;
};

/**
 * validar alfa numerico, guion y espacio
 */

const address = function($event) {
  let regex = new RegExp("^[a-zA-Z0-9-., ]+$");
  let key = String.fromCharCode(
    !$event.charCode ? $event.which : $event.charCode
  );
  if (!regex.test(key)) {
    $event.preventDefault();
    return false;
  }
};

const alphanumeric = function($event) {
  let regex = new RegExp("^[a-zA-Z0-9]+$");
  let key = String.fromCharCode(
    !$event.charCode ? $event.which : $event.charCode
  );
  if (!regex.test(key)) {
    $event.preventDefault();
    return false;
  }
};
const text = function($event) {
  let regex = new RegExp("^[a-zA-Z ]+$");
  let key = String.fromCharCode(
    !$event.charCode ? $event.which : $event.charCode
  );
  if (!regex.test(key)) {
    $event.preventDefault();
    return false;
  }
}
const validarSoloTexto = function($event) {
  let regex = new RegExp("^[a-zA-Z ]+$");
  let key = String.fromCharCode(
      !$event.charCode ? $event.which : $event.charCode
  );
  if (!regex.test(key)) {
      $event.preventDefault();
      return false;
  }
};


const numeric = function($event) {
  if (
    $event.charCode === 0 ||
    /\d/.test(String.fromCharCode($event.charCode))
  ) {
    return true;
  } else {
    $event.preventDefault();
  }
};


const price = function(value) {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
};

const maxLength = function(caracteres) {
    if (!caracteres) return null
    return caracteres.substr(0,35)
}

Vue.filter("filtroFecha", fecha)
Vue.filter("filtroFechaHora", fechaHora)
Vue.filter("filtroFullFechaHora", fullFechaHora)
Vue.filter("filtroFormatoHora", formatoHora)
Vue.filter("telefono", telefono)
Vue.filter("address", address)
Vue.filter("text", text)
Vue.filter("alphanumeric", alphanumeric)
Vue.filter("numeric", numeric)
Vue.filter("filterPrice", price)
Vue.filter("validarSoloTexto", validarSoloTexto)
Vue.filter('filtroCaracteres3',maxLength)
Vue.filter("dateformat", dateformat)
